import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import TeacherButton from "../../../atoms/button/TeacherButton";
import CategoryForm from "../../../organisms/teacher/CategoryForm";
import CategoryImage from "../../../assets/images/SettingStudents/category.png";
import { editCategoryPath, settingStudentsPath } from "../../../store/teacher";
import { IClass } from "../../../state";

import styles from "./SettingStudents.module.scss";

type Props = {
  assignedClasses: IClass[];
  calling: boolean;
  createCategory: (params: {
    name: string;
    class_ids: number[];
    color: string;
  }) => void;
};

const SettingStudents = ({
  assignedClasses,
  calling,
  createCategory,
}: Props) => {
  const history = useHistory();
  const [isShowCategoryForm, setIsShowCategoryForm] = useState(false);

  return (
    <>
      <div className={styles.contentsContainer}>
        <p className={styles.title}>「活かし先」設定</p>
        <div className={styles.mainContents}>
          <div className={styles.descriptionContainer}>
            <p className={styles.description}>
              学校・クラスで育てたい力やテーマを設定できます。
              <br />
              ここで設定した活かし先は、生徒のストック画面に表示され、生徒はストックを書く際に、どのテーマに活かすかを選択できます。テーマごとにストックが蓄積されることで、生徒の成長や変化を振り返り、分析に活用できます。
              <br />
              例：探究学習、キャリア教育、地域貢献、自己理解 など
            </p>
          </div>
          <div className={styles.buttonContainer}>
            <TeacherButton onClick={() => setIsShowCategoryForm(true)}>
              活かし先をつくる
            </TeacherButton>
            <TeacherButton
              customType="outline"
              onClick={() =>
                history.push(`${settingStudentsPath}${editCategoryPath}`)
              }
            >
              活かし先を編集
            </TeacherButton>
          </div>
        </div>
        <p className={styles.figTitle}>生徒ストック画面</p>
        <img
          src={CategoryImage}
          alt="生徒ストック画面"
          className={styles.categoryImage}
        />
      </div>
      <CategoryForm
        isOpen={isShowCategoryForm}
        assignedClasses={assignedClasses}
        calling={calling}
        onClose={() => setIsShowCategoryForm(false)}
        upsert={(params: {
          name: string;
          class_ids: number[];
          color: string;
        }) => {
          createCategory(params);
          setIsShowCategoryForm(false);
        }}
      />
    </>
  );
};

export default SettingStudents;
